import React from 'react'
import ReactDOM from 'react-dom/client'
import './assets/stylesheets/variables.css'
import './assets/stylesheets/global.css'
import 'semantic-ui-css/semantic.min.css'
import App from './App'
import store from './store'

import posthog from 'posthog-js'
import { PostHogProviderWrapper } from './PostHogProviderWrapper'
import { Provider } from 'react-redux'
import { ClerkProvider } from '@clerk/clerk-react'

const isProduction = window.location.host === 'kinstak.com'

// Only initialize PostHog in production to avoid unnecessary API calls
if (isProduction) {
  posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
    api_host: process.env.REACT_APP_API_POSTHOG_HOST,
    ui_host: process.env.REACT_APP_UI_POSTHOG_HOST,
    // We manually track pageviews in PosthogPageviewTracker.js
    capture_pageleave: false,
    // Only send events to posthog if the user is identified (i.e. logged in)
    person_profiles: 'identified_only'
  })
}

const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY
  || "pk_test_c3BsZW5kaWQtc2F3ZmlzaC0yMi5jbGVyay5hY2NvdW50cy5kZXYk"


const pageAfterSignIn = '/gallery'
const pageAfterSignOut = '/'

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <ClerkProvider
      publishableKey={clerkPublishableKey}
      afterSignOutUrl={pageAfterSignOut}
      signInForceRedirectUrl={pageAfterSignIn}
      signInFallbackRedirectUrl={pageAfterSignIn}
      signUpFallbackRedirectUrl={pageAfterSignIn}
      forceRedirectUrl={pageAfterSignIn}
      fallbackRedirectUrl={pageAfterSignIn}
      signUpForceRedirectUrl={pageAfterSignIn}
    >
      <PostHogProviderWrapper client={isProduction ? posthog : null}>
        <Provider store={store}>
          <App />
        </Provider>
      </PostHogProviderWrapper>
    </ClerkProvider>
  </React.StrictMode>
)
